<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 100 100"
       role="presentation"
       @click="$emit('click')">
    <g :fill="disabled ? disabledStateColor : iconColor">
      <path d="m50 62.301c5.5 0 10-4.5 10-9.8984v-30c0-5.5-4.5-9.8984-10-9.8984-5.5-0.003906-10 4.4961-10 9.8945v30c0 5.5 4.5 9.9023 10 9.9023zm0.10156 5.3984c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10z"/>
    </g>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
